import Splide from '@splidejs/splide';

export default function (el) {
    let imagesPerRow = el.closest('[data-block-type]').dataset.amount;

    if (imagesPerRow === '3') {
        let splide = new Splide(el, {
            type: 'loop',
            autoplay: true,
            pagination: false,
            perPage: 3,
            perMove: 1,
            gap: '3.5rem',
            breakpoints: {
                576: {
                    perPage: 1,
                },
                1200: {
                    perPage: 2,
                },
            },
        }).mount();

    } else {
        let splide = new Splide(el, {
            type: 'loop',
            autoplay: true,
            pagination: true,
        }).mount();
    }
}
